export const SET_ROOM_NAME = 'SET_ROOM_NAME'
export const SET_ROOM_STATE = 'SET_ROOM_STATE'
export const SET_TWILIO_TOKEN = 'SET_TWILIO_TOKEN'
export const SET_MASTER = 'SET_MASTER'
export const HANDLE_SET_IS_SPEAKING = 'HANDLE_SET_IS_SPEAKING'
export const SET_IS_SPEAKING = 'SET_IS_SPEAKING'
export const SET_STUDENTS_COUNT = 'SET_STUDENTS_COUNT'
export const SET_RECORDING_ALERT = 'SET_RECORDING_ALERT'
export const SET_IS_INTERACTION_MODE = 'SET_IS_INTERACTION_MODE'
export const SET_IS_ROOM_LOADING = 'SET_IS_ROOM_LOADING'
export const SET_CLASS_TITLE_AND_ROOM_TYPE = 'SET_CLASS_TITLE_AND_ROOM_TYPE'
export const HANDLE_PIP = 'HANDLE_PIP'
export const HANDLE_ROOM_STATE = 'HANDLE_ROOM_STATE'
export const SET_PARTICIPANT = 'SET_PARTICIPANT'
export const UPDATE_PARTICIPANT_INFO = 'UPDATE_PARTICIPANT_INFO'
export const SET_REMOTE_PARTICIPANTS = 'SET_REMOTE_PARTICIPANTS'
export const REMOVE_PARTICIPANT = 'REMOVE_PARTICIPANT'
export const UPDATE_DOMINANT_SPEAKER = 'UPDATE_DOMINANT_SPEAKER'
export const HANDLE_FULL_SCREEN_TOGGLE = 'HANDLE_FULL_SCREEN_TOGGLE'
export const UPDATE_CONNECTED_PARTICIPANT = 'UPDATE_CONNECTED_PARTICIPANT'
export const UPDATE_DISCONNECTED_PARTICIPANT = 'UPDATE_DISCONNECTED_PARTICIPANT'
export const UPDATE_NETWORK_BANDWIDTH_SAVER_MODE =
    'UPDATE_NETWORK_BANDWIDTH_SAVER_MODE'
export const UPDATE_IS_TEACHER_PRESENT = 'UPDATE_IS_TEACHER_PRESENT'
export const UPDATE_IS_ACTIVITY_MODE = 'UPDATE_IS_ACTIVITY_MODE'
